import type { AuthContextType } from "../auth/AuthContext";

const SUPPORTED_IMPORT_MARKETS = new Set(["smartstore", "gmarket", "auction", "eleventh", "lotteon", "ssgdotcom"]);

type SubscriptionFeature = "item_transfer" | "item_import";

function canAccessSubscriptionFeature(auth: AuthContextType, feature: SubscriptionFeature): boolean {
  if (auth.isImpersonating()) return true;
  return auth.subscriptionStatus?.[`allow_${feature}`] === true;
}

export function canAccessItemImport(auth: AuthContextType): boolean {
  return canAccessSubscriptionFeature(auth, "item_import");
}

export function canAccessItemTransfer(auth: AuthContextType): boolean {
  return canAccessSubscriptionFeature(auth, "item_transfer");
}

export function hasSupportedImportShop(shops: readonly { market_site: string }[]): boolean {
  return shops.some((shop) => SUPPORTED_IMPORT_MARKETS.has(shop.market_site));
}
